import React from "react";

function UsageSafety() {
    return (
        <section className="usage-safety-section">
            <div className="container">

                {/* HEADING */}
                <div className="text-center mb-5">
                    <h6 className="section-subtitle">USAGE & SAFETY</h6>
                    <h2 className="section-title">
                        Safe <span>Usage Guidelines</span>
                    </h2>
                    <p className="section-desc">
                        Proper application and safety practices ensure effective pest
                        control while protecting crops, farmers, and the environment.
                    </p>
                </div>

                <div className="row">

                    {/* USAGE */}
                    <div className="col-lg-6 mb-4">
                        <div className="usage-card">
                            <div className="usage-icon">🧪</div>
                            <h4>Recommended Usage</h4>
                            <ul>
                                <li>Always follow the recommended dosage mentioned on the product label.</li>
                                <li>Apply insecticides during early pest infestation for best results.</li>
                                <li>Ensure uniform spray coverage on crop foliage.</li>
                                <li>Use clean water and properly calibrated spraying equipment.</li>
                            </ul>
                        </div>
                    </div>

                    {/* SAFETY */}
                    <div className="col-lg-6 mb-4">
                        <div className="usage-card safety">
                            <div className="usage-icon">🛡️</div>
                            <h4>Safety Precautions</h4>
                            <ul>
                                <li>Wear protective clothing, gloves, and masks during application.</li>
                                <li>Avoid spraying during strong winds or extreme heat conditions.</li>
                                <li>Keep products away from children, animals, and food items.</li>
                                <li>Wash hands and equipment thoroughly after use.</li>
                            </ul>
                        </div>
                    </div>

                </div>

                {/* NOTE */}
                <div className="usage-note">
                    <p>
                        <strong>Important:</strong> Always read the product label and follow
                        local agricultural guidelines before use. Responsible application
                        helps protect both crop health and the environment.
                    </p>
                </div>

            </div>
        </section>
    );
};

export default UsageSafety;
